




















































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {利用者型} from '@/type/user/user';
import RegisterUser from '@/views/user/RegisterUser.vue';
import UpdateUser from '@/views/user/UpdateUser.vue';
import moment from 'moment';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {loginModule} from '@/store/authentication/login';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {progress} from '@/script/progress';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  filters: {
    dateFormat(date: Date): string {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
  components: {
    RegisterForm: RegisterUser,
    UpdateForm: UpdateUser,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class ListUsers extends Vue {

  private 利用者一覧: 利用者型[] = [];
  private 選択利用者: 利用者型 | null = null;

  private アラートメッセージ: string[] = [];

  private registerModal: boolean = false;
  private updateModal: boolean = false;

  private created(): void {
    this.show();
    viewEditingStateModule.初期化する();
  }

  private async show(): Promise<void> {
    await api.削除を含む利用者一覧を取得する()
      .then((response: any) => {
        this.利用者一覧 = response;
        if (this.利用者一覧.length === 0) {
          this.アラートメッセージ = ['利用者は存在しません'];
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.$modal.show('アラート');
      });
  }

  private select(利用者: 利用者型): void {
    if (this.isModalOpen) {
      return;
    }
    this.選択利用者 = 利用者;
  }

  private reload(): void {
    this.show();
    this.選択利用者 = null;
  }

  private openRegisterForm(): void {
    this.registerModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private closeRegisterForm(): void {
    this.reload();
    this.registerModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openUpdateForm(): void {
    this.updateModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private get isModalOpen(): boolean {
    return this.registerModal || this.updateModal;
  }

  private async requestUpdateForm(): Promise<void> {
    if (this.選択利用者 !== null) {
      this.openUpdateForm();
    }
  }

  private closeUpdateForm(): void {
    this.reload();
    this.updateModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openDeleteDialog(): void {
    this.$modal.show('deleteConfirmDialog');
  }

  private closeDeleteDialog(): void {
    this.$modal.hide('deleteConfirmDialog');
  }

  private deleteHandler(): void {
    progress(this.delete);
  }

  private async delete(): Promise<void> {
    if (this.選択利用者 !== null) {
      await api.利用者を削除する(this.選択利用者)
        .then(
          () => {
            this.closeDeleteDialog();
            this.reload();
          },
          (error: any) => {
            this.closeDeleteDialog();
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.$modal.show('アラート');
          },
        );
    }
  }

  private get isDisabled(): boolean {
    if (!this.isAdmin) {
      return true;
    }
    return this.選択利用者 === null || this.選択利用者.削除フラグ === '削除' || this.選択利用者.利用者コード === loginModule.利用者コードを取得する;
  }

  private get isAdmin(): boolean {
    return loginModule.管理者である;
  }
}
